export default "__VITE_ASSET__D4o0SfOc__"